import { forEach } from 'jszip';
import { TipoDocumento } from './../../Components/documentos-relacionados/shared/documentos-relacionados.model';
'use strict';
import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, FormArray } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';

import { FaturaService } from '../shared/fatura.service';
import { FaturaConfigService } from '../shared/fatura-config.service';

import { DocumentoCadastroComponent } from '../../documento/documento-cadastro/documento-cadastro.component';
import { InfoDialogComponent } from '../../core/dialogs/info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from '../../core/dialogs/confirm-dialog/confirm-dialog.component';

import { HtmlPrinterService } from '../../core/html-printer/html-printer.service';

import { Fatura } from '../shared/fatura.model';
import { ContaCadastroComponent } from '../../financeiro/conta-cadastro/conta-cadastro.component';
import { FaturaParcela } from '../shared/fatura-parcela.model';
import { NfseCadastroComponent } from 'src/app/fiscal/nfse-cadastro/nfse-cadastro.component';
import { EnviarEmailDialogComponent } from '../enviar-email-dialog/enviar-email-dialog.component';
import { NfeCadastroComponent } from 'src/app/fiscal/nfe-cadastro/nfe-cadastro.component';
import { of } from 'rxjs';
import { ConfirmacaoDivergenciaCservicoDialogComponent } from '../confirmacao-divergencia-cservico-dialog/confirmacao-divergencia-cservico-dialog.component';
import { DescontarRetencaoDialogComponent } from '../descontar-retencao-dialog/descontar-retencao-dialog.component';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { Moment } from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { FaturamentoLog } from '../shared/faturamentoLog.model';
import { FaturamentoLogComponent } from '../fatura-log/faturamento-log.component'

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface DialogData {
  faturaId: number;
  faturaTipo: number;
  faturaTipoDocumento: number;
}

@Component({
  selector: 'fatura-cadastro',
  templateUrl: 'fatura-cadastro.component.html',
  styleUrls: ['fatura-cadastro.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],

})
export class FaturaCadastroComponent {
  fatura: any = {};
  empresa: any = {};
  parceiro: any = {};
  empresas: any = [];
  faturaEmpresas: any = [];
  grupoContas: any = [];
  centroCustos: any = [];
  caixas: any = [];
  faturas: any = [];
  parceiros: any[];
  faturaParcelas: any[];
  faturaCadastroForm: FormGroup;
  maximizado: boolean;
  valorNuloServicoLista: number = null;
  tpFatura: number = 0;
  textoFatura: string = 'Venda';
  textoConta: string = 'contareceber';
  textoContaView: string = 'Conta a Receber';
  permiteAlteracao: boolean = false;
  permiteFaturamento: boolean = false;
  itemAdicionado: boolean = false;
  filteredProdutos: any[];
  parcelas: any[];
  servicosLista: any[];
  Logs: any[];
  formParcelas: FormGroup;
  faturaNfsesAndContaDto = {
    faturaId: 0,
    nfseIds: [],
    contaParcelaIds: [],
    contaIds: []
  };

  itemsGroupedDto: any;
  integracaoSOC: boolean;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<FaturaCadastroComponent>,
    private _formBuilder: FormBuilder,
    private htmlPrinterService: HtmlPrinterService,
    @Inject(MAT_DIALOG_DATA) public IFatura: DialogData,
    private faturaService: FaturaService,
    private faturaConfigService: FaturaConfigService
  ) { }

  ngOnInit() {
    this.maximizado = false;
    this.Logs = [];
    this.faturaCadastroForm = this._formBuilder.group(new Fatura());

    if (this.IFatura.faturaTipo == 0) {
      //this.textoTpFatura = 'faturavenda';
      this.textoFatura = 'Venda';
      this.textoConta = 'contareceber';
      this.textoContaView = 'Conta a Receber';
    } else {
      this.tpFatura = 1;
      //this.textoTpFatura = 'faturacompra';
      this.textoFatura = 'Compra';
      this.textoConta = 'contapagar';
      this.textoContaView = 'Conta a Pagar';
    }

    if (this.IFatura.faturaId > 0) {
      this.buscarFatura(this.IFatura.faturaId);
      this.ListLog(this.IFatura.faturaId);
    } else {
      this.fatura = {};

      this.fatura.faturaTipo = this.IFatura.faturaTipo;

      this.fatura.faturaId = 0;

      this.faturaCadastroForm
        .get('faturaTipo')
        .setValue(this.fatura.faturaTipo);

    }


    this.buscarEmpresas(this.tpFatura);

    this.buscarIntegracaoSOC();

    this.faturaCadastroForm.addControl(
      'parceiroAutoComplete',
      new FormControl('')
    );

    this.onChanges();

    this.restaurarDialog();
    //this.faturaCadastroForm.get('valorLiquido').disable();

    if (this.IFatura.faturaTipoDocumento == 0) {
      this.faturaCadastroForm.value.documentoFiscal = 3;
    }
  }

  onChanges(): void {
    this.faturaCadastroForm
      .get('parceiroAutoComplete')
      .valueChanges.pipe(
        debounceTime(300),
        switchMap((value) =>
          value?.length >= 3
            ? this.faturaService.getParceiroPorNome(value, this.tpFatura)
            : []
        )
      )
      .subscribe((data) => (this.parceiros = data.body));

    this.faturaCadastroForm.get('empresaId').valueChanges.subscribe((value) => {
      if (value) {
        this.getgrupoContas(this.tpFatura, value);
        this.getCaixas(this.tpFatura, value);
        this.getCentroCustos(this.tpFatura, value);
        this.buscaListaServico(value);

        // Em inclusão, pré-preenche os dados financeiros a partir da FaturaConfiguracao da empresa
        if (!this.IFatura.faturaId || this.IFatura.faturaId === 0) {
          this.preencherDadosConfig(value);
        }
      }
    });

    this.faturaCadastroForm.get('empresaFinanceiroId').valueChanges.subscribe((value) => {
      if (value && value > 0) {
        this.getgrupoContas(this.tpFatura, value);
        this.getCaixas(this.tpFatura, value);
        this.getCentroCustos(this.tpFatura, value);
        // Apenas reseta em inclusão, não em edição
        if (!this.IFatura.faturaId || this.IFatura.faturaId === 0) {
          this.faturaCadastroForm.get('grupoContaId').reset();
          this.faturaCadastroForm.get('caixaId').reset();
          this.faturaCadastroForm.get('centroCustoId').reset();
        }
      }
    });

    this.faturaCadastroForm.get('faturarParaOutraEmpresa').valueChanges.subscribe((value) => {
      const empresaFinanceiroField = this.faturaCadastroForm.get('empresaFinanceiroId');
      if (value) {
        // Quando marcar o checkbox: resetar campos e aguardar seleção de empresa
        this.faturaCadastroForm.get('grupoContaId').reset();
        this.faturaCadastroForm.get('caixaId').reset();
        this.faturaCadastroForm.get('centroCustoId').reset();
        empresaFinanceiroField.setValue(null);
      } else {
        // Quando desmarcar: voltar aos dados da empresa principal
        empresaFinanceiroField.setValue(null);
        const empresaId = this.faturaCadastroForm.get('empresaId').value;
        if (empresaId) {
          this.getgrupoContas(this.tpFatura, empresaId);
          this.getCaixas(this.tpFatura, empresaId);
          this.getCentroCustos(this.tpFatura, empresaId);
        }
      }
    });

   // this.faturaCadastroForm.get('valorLiquido').disable();
  }

  buscarEmpresas(faturaTipo: number) {
    this.faturaService.getEmpresas(faturaTipo).subscribe((data) => {
      this.empresas = data.body;
    });
  }

  selecionaCadastroFinanceiroEmpresa(empresa) {
    this.faturaCadastroForm.get('caixaId').setValue(empresa.caixaIdentificador);
    this.faturaCadastroForm.get('grupoContaId').setValue(empresa.grupoContaIdentificador);
    this.faturaCadastroForm.get('centroCustoId').setValue(empresa.centroCustoIdentificador);
    this.faturaEmpresas.push(empresa);
  }

  getgrupoContas(faturaTipo: number, empresaId: number) {
    this.faturaService.getgrupoContas(faturaTipo, empresaId).subscribe((data) => {
      this.grupoContas = data.body;
    });
  }

  getCaixas(faturaTipo: number, empresaId: number) {
    this.faturaService.getCaixas(faturaTipo, empresaId).subscribe((data) => {
      this.caixas = data.body;
    });
  }

  getCentroCustos(faturaTipo: number, empresaId: number) {
    this.faturaService.getCentroCustos(faturaTipo, empresaId).subscribe((data) => {
      this.centroCustos = data.body;
    });
  }

  // Busca a FaturaConfiguracao da empresa e pré-preenche os dados financeiros da fatura (somente em inclusão).
  preencherDadosConfig(empresaId: number) {
    this.faturaConfigService.getConfigPorEmpresa(empresaId, this.tpFatura).subscribe((config) => {
      if (!config) {
        return;
      }

      if (config.empresaFaturamentoFinanceiroId > 0) {
        // Config define faturamento financeiro para outra empresa: usa as opções dela
        this.faturaCadastroForm.get('faturarParaOutraEmpresa').setValue(true, { emitEvent: false });
        this.faturaCadastroForm.get('empresaFinanceiroId').setValue(config.empresaFaturamentoFinanceiroId, { emitEvent: false });
        this.getgrupoContas(this.tpFatura, config.empresaFaturamentoFinanceiroId);
        this.getCaixas(this.tpFatura, config.empresaFaturamentoFinanceiroId);
        this.getCentroCustos(this.tpFatura, config.empresaFaturamentoFinanceiroId);
      }

      this.faturaCadastroForm.get('grupoContaId').setValue(config.grupoContaId ?? null, { emitEvent: false });
      this.faturaCadastroForm.get('caixaId').setValue(config.caixaId ?? null, { emitEvent: false });
      this.faturaCadastroForm.get('centroCustoId').setValue(config.centroCustoId ?? null, { emitEvent: false });
    });
  }

  chosenYearHandler(normalizedYear: Moment) {
    let ctrlValue = this.faturaCadastroForm.get('mesAnoReferencia').value;
    if (!(ctrlValue instanceof Date)) {
      ctrlValue = new Date(ctrlValue);
    }
    ctrlValue.setFullYear(normalizedYear.year());
    this.faturaCadastroForm.get('mesAnoReferencia').setValue(ctrlValue);
  }

   chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Date>) {
    let ctrlValue = this.faturaCadastroForm.get('mesAnoReferencia').value;
    if (!(ctrlValue instanceof Date)) {
      ctrlValue = new Date(ctrlValue);
    }
    ctrlValue.setMonth(normalizedMonth.month());
    this.faturaCadastroForm.get('mesAnoReferencia').setValue(ctrlValue);
    datepicker.close();
  }

  buscarIntegracaoSOC() {
    this.faturaService.getIntegracoesSOC().subscribe(data => {
      if (data.body) {
        this.integracaoSOC = true;
      }
    });
  }



  fecharDialog(atualizou: boolean = false) {
    this.dialogRef.close(atualizou);
  }

  maximizarDialog() {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog() {
    let innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('100%', '100vh');
    } else {
      this.dialogRef.updateSize('80%', '100vh');
    }

    this.maximizado = false;
  }

  buscarFatura(faturaId: number) {
    this.faturaService.getFatura(faturaId).subscribe(
      (data) => {
        this.InsereDadosFatura(data.body);
      },
      (error: HttpErrorResponse) => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: 'Erro',
            erro: error,
          },
        });
      }
    );
  }

  cancelarFatura(cancelarId) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: 'Confirmação',
        mensagem:
          'Deseja realmente Cancelar essa fatura? \n' +
          'Esse processo também irá cancelar a Conta e Boletos vinculados se houver.',
      },
      maxWidth: '200px',
      minHeight: '250px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.faturaService.deleteFatura(cancelarId).subscribe(
          (data) => {
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                titulo: 'Sucesso',
                mensagem: 'Registro Cancelado com Sucesso',
              },
            });

            this.buscarFatura(cancelarId);
          },
          (error: HttpErrorResponse) => {
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                titulo: 'Erro',
                erro: error,
              },
            });
          }
        );
      }
    });
  }

  imprimir(): void {
    if(this.faturaCadastroForm.value.valorLiquido == null){
      this.faturaCadastroForm.value.valorLiquido == 0
    }

   this.faturaService
      .postImprimir(this.faturaCadastroForm.value)
      .subscribe((data) => {

        let titulo = 'Fatura';

        this.htmlPrinterService.imprimirConteudoTinyMCE(data.body.htmlString, 0.73);
      });


  }



  PreencherTabela(cliente: any) {
    if (cliente != undefined) {
      this.fatura.clienteId = cliente.clienteId;
    }
  }





  DeleteFaturaParcela(faturaParcelaId) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: 'Confirmação',
        mensagem: 'Deseja realmente excluir essa parcela?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.faturaService.deleteFaturaParcela(faturaParcelaId).subscribe(
          (data) => {
            this.buscarFatura(this.fatura.faturaId);
          },
          (error: HttpErrorResponse) => {
            const dialogRef = this.dialog.open(InfoDialogComponent, {
              data: {
                titulo: 'Erro',
                erro: error,
              },
            });
          }
        );
      }
    });
  }



  VisualizaFluxoDocumentos(): void {
    const dialogRef = this.dialog.open(DocumentoCadastroComponent, {
      data: {
        tipoOrigem: 8,
        idDocumento: this.fatura.faturaId,
      },
      maxHeight: '100vh',
    });
  }

  verificarFaturaTipo(faturaTipo: number) {
    if (faturaTipo == 0) {
      this.textoFatura = 'Venda';
      this.textoConta = 'contareceber';
      this.textoContaView = 'Conta a Receber';
    } else {
      this.tpFatura = 1;
      this.textoFatura = 'Compra';
      this.textoConta = 'contapagar';
      this.textoContaView = 'Conta a Pagar';
    }
  }

  verificaFaturaStatus(faturaStatus: number) {
    return this.faturaService.verificaFaturaStatus(faturaStatus);
  }



  async gerarNfseConta() {
    this.verififyifHaveGrupoContaIdAndCaixaIdInFatura();


    try {
      const data = await this.faturaService
        .postVerificaCServicoDiferentes(this.faturaCadastroForm.value)
        .toPromise();
        this.itemsGroupedDto = data.body;
    } catch (error) {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: 'Erro',
          erro: error,
        },
      });
    }

    let valorDivergencia = 0;
    let valorTotalDosServicosNfses = 0;
    let quantidadeNotas = 0;

    if (this.itemsGroupedDto.length > 0) {

      try {
        const buscaDivergencia = await this.faturaService
          .postBuscaValorRetencaoNfses(this.itemsGroupedDto)
          .toPromise();
        buscaDivergencia.body.forEach((item) => {
          valorDivergencia += item.valorServicos - item.valorLiquidoNfse;
          valorTotalDosServicosNfses += item.valorServicos;
        });

        quantidadeNotas = buscaDivergencia.body.length;
      } catch (error) {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: 'Erro',
            erro: error,
          },
        });
      }

    }


    const mensagem = `Esta(s) nota(s) fiscal(is) conterá(ão) o valor de R$ ${valorDivergencia.toFixed(2)} em retenções. Deseja descontar o valor dessas retenções no boleto e na conta a receber gerados?`

    if (valorDivergencia > 0) {
      const confDialog = this.dialog.open(DescontarRetencaoDialogComponent, {
        data: {
          mensagem: mensagem,
        },
      });

      confDialog.afterClosed().subscribe((result) => {

        this.definirProximosPassosRetencao(result)


      });
    }else{
      this.definirProximosPassosRetencao(2);
    }
  }

  definirProximosPassosRetencao(result: number) {
    const documentoFiscal = this.faturaCadastroForm.value.documentoFiscal;
        const atualizaValoresRetencao = result == 1;

        if ((result == 1 || result == 2) && documentoFiscal == 2) {
          this.addNfse(true, atualizaValoresRetencao);
        }

        if ((result == 1 || result == 2) && documentoFiscal == 1) {
          if (this.itemsGroupedDto.length > 1) {
            const dialogConfirmaDivergencia = this.dialog.open(
              ConfirmacaoDivergenciaCservicoDialogComponent,
              {
                data: {
                  faturaItensCodigoServicoDto: this.itemsGroupedDto,
                },
                maxHeight: '100vh',
                maxWidth: '20vw',
              }
            );

            dialogConfirmaDivergencia.afterClosed().subscribe((dialogResult) => {
              if (dialogResult) {

                this.addNfse(true, atualizaValoresRetencao);
              }
            });
          } else {
            this.addNfse(true, atualizaValoresRetencao);
          }
        }
  }

  gerarNfeConta() {
    this.verififyifHaveGrupoContaIdAndCaixaIdInFatura();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        titulo: "Gerar Conta",
        mensagem: "Esse procedimento irá gerar uma NF-e e " +
          "criar a Conta a Receber." +
          "Deseja continuar?"
      }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {
        this.gerarConta();
        this.gerarNFe(this.fatura.faturaId)
      }
    });
  }

  async deconstaValoreRetencoes() {
    let valorDivergencia = 0;
    let valorTotalDosServicosNfses = 0;
    let quantidadeNotas = 0;

    if (this.itemsGroupedDto.length > 0) {
      try {
        const buscaDivergencia = await this.faturaService
          .postBuscaValorRetencaoNfses(this.itemsGroupedDto)
          .toPromise();
        buscaDivergencia.body.forEach((item) => {
          valorDivergencia += item.valorServicos - item.valorLiquidoNfse;
          valorTotalDosServicosNfses += item.valorServicos;
        });

        quantidadeNotas = buscaDivergencia.body.length;
      } catch (error) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            titulo: 'Erro',
            erro: error,
          },
        });
      }
    }

    const mensagem = `Foi identificada uma retenção no valor total de R$ ${valorDivergencia.toFixed(2)}. Deseja aplicar esse valor como desconto nas contas a receber geradas?`;

    if (valorDivergencia > 0) {
      const confDialog = this.dialog.open(DescontarRetencaoDialogComponent, {
        data: {
          mensagem: mensagem,
        },
      });

      const result = await confDialog.afterClosed().toPromise();
      return result;
    }

    return null;
  }

  async gerarConta(geraSomenteNfse: boolean = false) {
    this.verififyifHaveGrupoContaIdAndCaixaIdInFatura();
    if (geraSomenteNfse && this.faturaCadastroForm.value.documentoFiscal == 1 ) {
      const resultado = await this.verificaDivergenciasCodigoServicosItens();

      if (!resultado) {
        return;
      }
    }

    this.faturaService
      .postGerarConta(this.faturaCadastroForm.value, false)
      .subscribe(
        (data) => {
          this.faturaNfsesAndContaDto.contaParcelaIds = data.body.contaParcelaIds;

          if (this.faturaNfsesAndContaDto?.contaParcelaIds?.length > 1) {
            this.openContAReceberNextTab();
          } else {
            this.abreModalConta(
              this.faturaCadastroForm.value.faturaTipo,
              data.body.contaIds[0],
              this.faturaCadastroForm.value.faturaTipo
            );
          }


          this.buscarFatura(this.fatura.faturaId);
        },
        (error: HttpErrorResponse) => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: 'Erro',
              erro: error,
            },
          });
        }
      );
  }


  async gerarContaEBoleto(atualizaValoresRetencao: boolean, geraSomenteNfse: boolean = false) {
    this.verififyifHaveGrupoContaIdAndCaixaIdInFatura();
    if (geraSomenteNfse) {
      const resultado = await this.verificaDivergenciasCodigoServicosItens();

      if (!resultado) {
        return;
      }
    }

    this.faturaService
      .postGerarContaBoleto(this.faturaCadastroForm.value, atualizaValoresRetencao)
      .subscribe(
        (data) => {
          this.faturaNfsesAndContaDto.contaParcelaIds = data.body.contaParcelaIds;

          if (this.faturaNfsesAndContaDto?.contaParcelaIds?.length >= 1) {
            this.openContAReceberNextTab();
          }


          this.buscarFatura(this.fatura.faturaId);

        },
        (error: HttpErrorResponse) => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: 'Erro',
              erro: error,
            },
          });
        }
      );
  }

  verificaDivergenciasCodigoServicosItens(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.faturaCadastroForm.value.documentoFiscal == 2 || this.faturaCadastroForm.value.faturaTipo == 1) {
        resolve(true);
      } else {
        this.faturaService.postVerificaCServicoDiferentes(this.faturaCadastroForm.value)
          .toPromise()
          .then((data) => {
            this.itemsGroupedDto = data.body;

            if(this.itemsGroupedDto.length < 2) {
              resolve(true);
              return;
            }

            const dialogConfirmaDivergencia = this.dialog.open(
              ConfirmacaoDivergenciaCservicoDialogComponent,
              {
                data: {
                  faturaItensCodigoServicoDto: this.itemsGroupedDto,
                },
                maxHeight: '100vh',
                maxWidth: '20vw',
              }
            );

            dialogConfirmaDivergencia.afterClosed().subscribe((dialogResult) => {
              if (!dialogResult) {
                resolve(false);
              } else {
                resolve(true);
              }
            });
          })
          .catch((error) => {
            this.dialog.open(InfoDialogComponent, {
              data: {
                titulo: 'Erro',
                erro: error,
              },
            });
            resolve(false);
          });
      }
    });
  }

  async addNfse(gerarGerarConta: boolean, atualizaValoresRetencao: boolean, geraSomenteNfse: boolean = false) {
    this.verififyifHaveGrupoContaIdAndCaixaIdInFatura();
    if (geraSomenteNfse) {
      const resultado = await this.verificaDivergenciasCodigoServicosItens();

      if (!resultado) {
        return;
      }
    }

    this.faturaService
      .postGerarNfse(this.faturaCadastroForm.value)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.dialog.open(InfoDialogComponent, {
            data: {
              erro: error,
              mensagem: 'Erro ao gerar a NFSe',
              titulo: 'Erro'
            }
          });

          return of(null);
        })
      )
      .subscribe(async (data) => {
        if (data) {
          this.faturaNfsesAndContaDto.nfseIds = data.body.nfseIds;
          if (this.faturaNfsesAndContaDto.nfseIds.length >= 1) {
            if (gerarGerarConta) {

              this.gerarContaEBoleto(atualizaValoresRetencao);
            }

            this.verifyIfOpenNewWindowOrVisualizeNfse(data.body.nfseIds);

          }
        }
      });
  }

  verifyIfOpenNewWindowOrVisualizeNfse(nfseIds: number[]) {

    if (nfseIds.length > 1) {
      this.openNfseNextTab();
    } else {
      this.visualizarNfse(nfseIds[0]);
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  getNfsesAndContasByFaturaId(faturaId: number) {
    this.faturaService.getNfsesAndContasByFaturaId(faturaId).subscribe((data) => {
      this.faturaNfsesAndContaDto = data.body;
    });
  }

  gerarNFe(faturaId): void {

    this.faturaService.postGerarNfe(faturaId).subscribe(data => {

      const dialogRef = this.dialog.open(InfoDialogComponent, {
        data: {
          titulo: "Sucesso",
          mensagem: "NF-e Gerada com Sucesso"
        }
      });

      this.VisualizaNFe(data.body.nfeId);

    });
  }

  openNfseNextTab() {
    let nfseIds = this.faturaNfsesAndContaDto.nfseIds.join(',');
    let url = `#/fiscal/nfse?nfseIds=${nfseIds}`;
    window.open(url, '_blank');

  }

  openContAReceberNextTab() {
    let contaParcelaIds = this.faturaNfsesAndContaDto.contaParcelaIds;
    let url = `#/financeiro/contareceber?contaParcelaIds=${contaParcelaIds}`;
    window.open(url, '_blank');

  }

  VisualizaNFe(nfeId: number) {

    const dialogRef = this.dialog.open(NfeCadastroComponent, {
      data: {
        nfeId: nfeId,
      },
      maxHeight: '100vh',
      maxWidth: '100vw',
      panelClass: ['custom-dialog', 'nf-z-index'],
    });

    dialogRef.afterClosed().subscribe(result => {
      this.buscarFatura(this.IFatura.faturaId);
    });

  }

  DeterminaParceiro(parceiro: any) {
    if (this.tpFatura == 0) {
      this.faturaCadastroForm.get('parceiroId').setValue(parceiro.clienteId);
    } else {
      this.faturaCadastroForm.get('parceiroId').setValue(parceiro.fornecedorId);
    }
  }

  AdicionarNovaParcelaVazia() {
    var parcela: any = {};

    parcela.dataVencimento = new Date();
    parcela.valorParcela = 0;
    parcela.faturaId = this.fatura.faturaId;

    this.faturaParcelas.push(parcela);
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  EnviaEmail(faturaFormTemp: any) {
    const dialogRef = this.dialog.open(EnviarEmailDialogComponent, {
      data: {
        titulo: 'Enviar Email',
        faturaFormTemp: faturaFormTemp.value,
      },
    });
  }

  atualizarValorBruto() {
    let valorBruto = this.faturaCadastroForm.get('valorBruto').value;
    let valorDesconto = this.faturaCadastroForm.get('valorDesconto').value;

    let valorLiquido = valorBruto - valorDesconto;

    this.faturaCadastroForm.get('valorLiquido').setValue(valorLiquido);
  }

  visualizarNfse(id: number) {
    const ufId = this.empresa.municipio.uf.ufId;
    const municipioId = this.empresa.municipio.municipioId;


    const dialogRef = this.dialog.open(NfseCadastroComponent, {
      data: {
        nfseId: id,
        ufId: ufId,
        municipioId: municipioId,
      },
      panelClass: 'custom-visualizar-nfse-dialog',
      maxHeight: '100vh',
    });
  }

  abreModalConta(tpConta: number, contaId: number, tipoParceiro: number) {
    const dialogRef = this.dialog.open(ContaCadastroComponent, {
      data: {
        contaId: contaId,
        tpConta: tpConta,
        tipoParceiro: tipoParceiro,
      },
      maxHeight: '100vh',
      maxWidth: '100vw',
      panelClass: 'custom-visualizar-contaReceber-dialog',

    });
  }

  //Adicionando novas funcionalidade para o componente fatura

  //Função para buscar produtos por nome e empresas
  getProdutoPorNomeEEmpresasService(params: any) {

    //se for fatura de compra do tipo serviço, deixa cadastrar manual
    if(this.IFatura?.faturaTipo==1 && this.IFatura?.faturaTipoDocumento==3){

      return of([]);

    }

    if (params.empresasIds.length > 1) {
      params.empresasIds.splice(1, params.empresasIds.length - 1);
    }

    params.faturaTipoDocumento = this.IFatura.faturaTipoDocumento;

    return this.faturaService.getProdutoPorNomeEEmpresas(params);

  }

  //Função para adicionar item na fatura
  onItensChange(itens: any[]): void {

    // Acessa o valor do array de faturaItens
    const faturaItens = itens
    // Atualiza as propriedades dos itens no array
    itens.forEach((item, index) => {
      const itemEntregaPayload = this.montarEntregaPayload(item);
      const faturaSubitens = (item.subitens || []).map((sub: any) => {
        const entregaSub = this.montarEntregaPayload(sub);
        return {
          faturaSubitemId: sub.faturaSubitemId || 0,
          faturaItemId: item.faturaItemId || 0,
          produtoId: sub.produtoId && sub.produtoId > 0 ? sub.produtoId : null,
          // FK (int?): só preenche quando a entrega já existe. Nova entrega → null (EF atribui após o insert).
          entregaId: entregaSub && entregaSub.entregaId > 0 ? entregaSub.entregaId : null,
          descricao: sub.descricao,
          quantidade: sub.quantidade,
          valorUnitario: sub.valorUnitario,
          valorDescontoUnitario: sub.valorDescontoUnitario,
          valorTotalBruto: sub.valorTotalBruto,
          valorTotalDesconto: sub.valorTotalDesconto,
          valorTotalLiquido: sub.valorTotalLiquido,
          entrega: entregaSub,
        };
      });

      // Só envia o objeto `produto` se for um Produto válido (objeto com produtoId > 0).
      // Itens livres (fatura de serviço sem produtoId) → produto: null e produtoId: null,
      // evitando que o Newtonsoft tente converter a string da descrição em Produto.
      const produtoValido = item.produto && typeof item.produto === 'object' && item.produto.produtoId > 0
        ? item.produto
        : (item.item && typeof item.item === 'object' && item.item.produtoId > 0 ? item.item : null);

      const produtoIdValido = item.produtoId && item.produtoId > 0 ? item.produtoId : null;

      const itemFormatado = {
        faturaParcelaId: item.faturaItemId || 0,
        descricao: item.descricao,
        qtdComercial: item.quantidade || item.qtdComercial,
        faturaId: this.fatura.faturaId,
        valorDesconto: item.descontoUnitario,
        produto: produtoValido,
        produtoId: produtoIdValido,
        valorBruto: item.valorTotalBruto,
        valorTotal: item.valorTotalLiquido,
        valorUnitario: item.valorUnitario,
        // FK (int?): só preenche quando a entrega já existe. Nova entrega → null (EF atribui após o insert).
        entregaId: itemEntregaPayload && itemEntregaPayload.entregaId > 0 ? itemEntregaPayload.entregaId : null,
        entrega: itemEntregaPayload,
        faturaSubitens: faturaSubitens
      };

      // Atualiza o item no array existente
      if (faturaItens[index]) {
        Object.assign(faturaItens[index], itemFormatado);
      } else {
        faturaItens.push(itemFormatado);
      }
    });

    // Atualiza o valor do form control
    this.faturaCadastroForm.get('faturaItens').setValue(faturaItens, { emitEvent: false });

  }

  /**
   * Monta o payload de Entrega compatível com o backend.
   * - Retorna null quando não há dados de entrega (nem id, nem nenhum campo preenchido). Nesse caso,
   *   o FK FaturaItem/FaturaSubitem.EntregaId (int?) também vai como null — nenhuma entrega é enviada.
   * - Caso contrário, envia o objeto completo. A PK Entrega.EntregaId é `int` não-nullable no backend,
   *   portanto:
   *     * Entrega existente → entregaId = número do id.
   *     * Entrega nova      → entregaId = 0 (EF trata como insert).
   */
  private montarEntregaPayload(origem: any): { entregaId: number; localEntrega: string; nomeDestinatario: string; cpfDestinatario: string; setorDestinatario: string; dataEntrega: string | null } | null {
    const entrega = origem?.entrega;

    const entregaIdBruto = entrega && entrega.entregaId != null
      ? entrega.entregaId
      : origem?.entregaId;

    const entregaIdNumero = entregaIdBruto != null ? Number(entregaIdBruto) : 0;
    const entregaIdExistente = entregaIdNumero > 0 ? entregaIdNumero : 0;

    const localEntrega = (entrega?.localEntrega || '').trim();
    const nomeDestinatario = (entrega?.nomeDestinatario || '').trim();
    const cpfDestinatario = (entrega?.cpfDestinatario || '').trim();
    const setorDestinatario = (entrega?.setorDestinatario || '').trim();
    const dataEntrega = entrega?.dataEntrega
      ? (entrega.dataEntrega instanceof Date
          ? entrega.dataEntrega.toISOString()
          : new Date(entrega.dataEntrega).toISOString())
      : null;

    const temDados = entregaIdExistente > 0 || localEntrega || nomeDestinatario || cpfDestinatario || setorDestinatario || dataEntrega;
    if (!temDados) return null;

    return {
      entregaId: entregaIdExistente,
      localEntrega,
      nomeDestinatario,
      cpfDestinatario,
      setorDestinatario,
      dataEntrega,
    };
  }

  //Função para adicionar valor total bruto
  onValorTotalBrutoChange(valorTotalBruto: number) {
    this.faturaCadastroForm.get('valorBruto').setValue(valorTotalBruto);
  }

  //Função para adicionar descontos globalmente


  //Função para valor total liquido
  onValorTotalLiquidoChange(valorTotalLiquidoItens: number) {
    const valorAnterior = this.faturaCadastroForm.get('valorLiquido').value || 0;
    const valorTotalLiquido = valorTotalLiquidoItens;
    this.faturaCadastroForm.get('valorLiquido').setValue(valorTotalLiquido);

    const parcelas: any[] = this.faturaCadastroForm.get('faturaParcelas').value;
    const diferenca = Number((valorTotalLiquido - valorAnterior).toFixed(2));
    if (parcelas && parcelas.length > 0 && Math.abs(diferenca) >= 0.01) {
      const ajustePorParcela = Number((diferenca / parcelas.length).toFixed(2));
      const ajusteUltima = Number((diferenca - ajustePorParcela * (parcelas.length - 1)).toFixed(2));
      const parcelasAtualizadas = parcelas.map((parcela: any, index: number) => ({
        ...parcela,
        valorLiquido: Number((parcela.valorLiquido + (index === parcelas.length - 1 ? ajusteUltima : ajustePorParcela)).toFixed(2))
      }));
      this.faturaCadastroForm.get('faturaParcelas').setValue(parcelasAtualizadas);
      this.faturaParcelas = parcelasAtualizadas;
    }
  }

  //Função para adicionar parcelas
  onParcelasFinaisChange(parcelas: any[]) {
    const parcelasFinais = parcelas?.map((parcela: any) => ({
      faturaParcelaId: parcela.parcelaId,
      dataVencimento: parcela.dataVencimentoParcela,
      valorLiquido: parcela.valorLiquido,
      tipoPagamento: parcela.tipoPagamento
    }));
    this.faturaCadastroForm.get('faturaParcelas').setValue(parcelasFinais);
    this.validarSomaParcelasIgualValorLiquido();
  }

  validarSomaParcelasIgualValorLiquido(): boolean {
    const parcelas = this.faturaCadastroForm.get('faturaParcelas').value;
    const valorLiquidoTotal = this.faturaCadastroForm.get('valorLiquido').value;

    if (!parcelas || !valorLiquidoTotal) {
      return false;
    }

    const somaParcelas = parcelas.reduce((sum, parcela) => sum + (parcela.valorLiquido || 0), 0);
    return Math.abs(somaParcelas - valorLiquidoTotal) < 0.01;
  }

  validarQuantidadesItens(): boolean {
    if (!this.fatura?.faturaItens || this.fatura.faturaItens.length === 0) {
      return true;
    }
    return !this.fatura.faturaItens.some(item => item.qtdComercial <= 0);
  }

  salvar(faturaCadastroForm: FormGroup): void {
    let faturaForm = this.faturaCadastroForm;

    var fatura = this.fatura;

    fatura.cliente = null;
    fatura.empresa = null;

    if (this.tpFatura == 0) {
      fatura.faturaTipo = 0;
    } else {
      fatura.tpFatura = 1;
    }

    const raw = faturaForm.value.servicoListaId;
      faturaForm.value.servicoListaId = (raw === "-1" ? null : raw);
    if (faturaForm.value.faturaId == 0 || faturaForm.value.faturaId == null) {
      if (faturaForm.value.faturaItens.length == 0) {
        this._snackBar.open('É necessário adicionar ao menos um item na fatura.', 'Fechar', {
          duration: 5000,
          panelClass: ['mat-toolbar', 'warn']
        });
        return;
      }

      //seta os valores dos itens da fatura
      faturaForm.value.faturaItens.forEach(item => {
        item.qtdComercial = item.quantidade;
        item.valorUnitarioComercial = item.valorUnitario;
        item.ValorUnitario = item.valorUnitario;
        item.valorBruto = item.valorUnitario * item.quantidade;
        item.valorDesconto = item.descontoUnitario * item.quantidade;
        item.valorTotal = item.valorBruto - item.valorDesconto;
        item.valorTotalLiquido = item.valorTotal;
      });


      //verificar se as parcelas estão preenchidas
      if (faturaForm.value.faturaParcelas.length == 0) {
        this._snackBar.open('É necessário adicionar ao menos uma parcela na fatura.', 'Fechar', {
          duration: 5000,
          panelClass: ['mat-toolbar', 'warn']
        });
        return;
      }

      //pegar os valores das parcelas
      this.parcelas = faturaForm.value.faturaParcelas;

      //pegar o tipo de pagamento das parcelas e salva no tipo de pagamento da fatura
      faturaForm.value.tipoPagamento = this.parcelas[0].tipoPagamento;

      //seta os valores das parcelas
      this.parcelas.forEach(parcela => {
        parcela.faturaParcelaId = 0;
        parcela.parcelaId = 0;
        parcela.dataVencimento = parcela.dataVencimento;
        parcela.valorParcela = parcela.valorLiquido;
        parcela.valorBruto = parcela.valorLiquido;

      });

      faturaForm.value.valorLiquido = faturaForm.value.valorTotal;
      faturaForm.value.faturaParcelas = this.parcelas;
      faturaForm.value.faturaTipoDocumento = this.IFatura.faturaTipoDocumento;



      this.faturaService.NovaFatura(faturaForm.value).subscribe((data) => {
        this._snackBar.open('Fatura criada com sucesso!', 'Fechar', {
          duration: 5000,
          panelClass: ['mat-toolbar', 'sucess']
        });

        this.dialogRef.close(true);
      });
    } else {
      let faturaTemp = faturaForm.value;

      if (!faturaTemp.faturarParaOutraEmpresa) {
        faturaTemp.empresaFinanceiroId = null;
      }

      faturaTemp.faturaParcelas = faturaForm.value.faturaParcelas;

      //adicionar os valores das parcelas
      faturaTemp.faturaParcelas.forEach(parcela => {
        parcela.dataVencimento = parcela.dataVencimento;
        parcela.valorParcela = parcela.valorLiquido;
        parcela.valorBruto = parcela.valorLiquido;
      });

      this.faturaService
        .putFatura(faturaTemp, faturaTemp.faturaTipo)
        .subscribe((data) => {
          this._snackBar.open('Registro Salvo com Sucesso');

          this.dialogRef.close(true);
        });
    }
  }

InsereDadosFatura(data: any) {
    this.faturaCadastroForm.patchValue(data.fatura);
    let nomeAutoCompleteParceiro = data.parceiro.nomeFantasia !== "" ? data.parceiro.nomeFantasia : data.parceiro.razaoSocial;
    this.faturaCadastroForm
      .get('parceiroAutoComplete')
      .setValue(nomeAutoCompleteParceiro);

    if (data.fatura?.empresaFinanceiroId > 0) {
      this.faturaCadastroForm.get('faturarParaOutraEmpresa').setValue(true, { emitEvent: false });
    }

    this.fatura = data.fatura;

    this.empresa = data.empresa;
    this.parceiro = data.parceiro;

    const servicoListaId = data?.fatura?.servicoListaId;
this.faturaCadastroForm.get('servicoListaId')
  ?.setValue(servicoListaId == null ? "-1" : servicoListaId, { emitEvent: false });

    // Seta os valores dos itens da fatura
    data.fatura.faturaItens.forEach(item => {
      item.quantidade = item.qtdComercial;
      item.descontoUnitario = item.valorDesconto / item.quantidade;
      item.valorTotalLiquido = item.valorTotal;
      item.valorTotalBruto = item.valorBruto;
      item.entrega = item.entrega || (item.entregaId ? { entregaId: item.entregaId, localEntrega: '', nomeDestinatario: '', cpfDestinatario: '', setorDestinatario: '', dataEntrega: null } : null);
      // Mapeia faturaSubitens (backend) para subitens (formato esperado pelo componente filho app-itens)
      item.subitens = (item.faturaSubitens || []).map((sub: any) => ({
        faturaSubitemId: sub.faturaSubitemId,
        descricao: sub.descricao,
        produtoId: sub.produtoId || 0,
        produtoTipo: sub.produto?.produtoTipo || 0,
        quantidade: sub.quantidade,
        valorUnitario: sub.valorUnitario,
        valorDescontoUnitario: sub.valorDescontoUnitario,
        valorTotalBruto: sub.valorTotalBruto,
        valorTotalDesconto: sub.valorTotalDesconto,
        valorTotalLiquido: sub.valorTotalLiquido,
        entregaId: sub.entregaId ?? null,
        entrega: sub.entrega || (sub.entregaId ? { entregaId: sub.entregaId, localEntrega: '', nomeDestinatario: '', cpfDestinatario: '', setorDestinatario: '', dataEntrega: null } : null),
      }));
    });

    let parcelas = data.fatura.faturaParcelas;

    this.faturaParcelas = parcelas.map(parcela => ({
      dataVencimento: new Date(parcela.dataVencimento),
      faturaParcelaId: parcela.faturaParcelaId,
      valorLiquido: parcela.valorParcela,
      tipoPagamento: parcela.tipoPagamento
    }));

    this.faturaCadastroForm.get('faturaParcelas').setValue(this.faturaParcelas);

    this.verificarFaturaTipo(this.fatura.faturaTipo);
    const empresaParaFiltro = this.fatura.empresaFinanceiroId > 0 ? this.fatura.empresaFinanceiroId : this.empresa.empresaId;
    this.getgrupoContas(this.tpFatura, empresaParaFiltro);
    this.getCaixas(this.tpFatura, empresaParaFiltro);
    this.getCentroCustos(this.tpFatura, empresaParaFiltro);

    this.faturas = [this.fatura];

    if (this.fatura.faturaStatus == 4 || this.fatura.faturaStatus == 99 || this.fatura.faturaStatus == 1) {
      this.faturaCadastroForm.disable();
      this.permiteAlteracao = false;
    }

    if (this.fatura.faturaId > 0 ) {
      this.permiteFaturamento = true;
    } else {
      this.permiteFaturamento = false;
    }

    this.faturaCadastroForm.value.valorLiquido = 0;

    for (let i = 0; i < this.faturas[0].faturaItens.length; i++) {
      this.faturaCadastroForm.value.valorLiquido +=
        this.faturas[0].faturaItens[i].valorLiquido;
    }

    this.itemAdicionado = this.fatura.faturaItens.length > 0;

    this.faturaEmpresas.push(this.empresa);
    this.getNfsesAndContasByFaturaId(this.fatura.faturaId);
  }

  verififyifHaveGrupoContaIdAndCaixaIdInFatura() {

    if (!this.faturaCadastroForm.value.grupoContaId || !this.faturaCadastroForm.value.caixaId) {
        this._snackBar.open('Por favor, selecione a Categoria de Contas a Receber e o Caixa para continuar.', 'Fechar', {
        duration: 5000,
        panelClass: ['mat-toolbar', 'warn']
      });

      throw new Error('É necessário selecionar Categoria do Contas a Receber e Caixa.');
    }
  }


  async gerarNfseContaBoleto(){
    if(this.faturaCadastroForm.value.valorLiquido>0){

      let variasNotas = this.verificaSeOsItensPossuemListaServicoDiferentes();

      if(variasNotas){

       const data = await this.faturaService
        .postVerificaCServicoDiferentes(this.faturaCadastroForm.value)
        .toPromise();
        this.itemsGroupedDto = data.body;

         if (this.itemsGroupedDto.length > 1) {
            const dialogConfirmaDivergencia = this.dialog.open(
              ConfirmacaoDivergenciaCservicoDialogComponent,
              {
                data: {
                  faturaItensCodigoServicoDto: this.itemsGroupedDto,
                },
                width: '60%',
              }
            );

            dialogConfirmaDivergencia.afterClosed().subscribe((dialogResult) => {
              if (dialogResult) {

               //chamar transmissão nota
              }
            });
          } else {
             //chamar transmissão nota
          }
      }

    }else{
       this._snackBar.open('O valor da fatura está zerado. Adicione itens com valores maiores do que zero para continuar', 'Fechar', {
        duration: 5000,
        panelClass: ['mat-toolbar', 'warn']
      });
    }
  }

  verificaSeOsItensPossuemListaServicoDiferentes(){
    const itens = this.faturaCadastroForm.value.faturaItens;
    const valoresUnicos = new Set(itens.map(i => i.produto.servicoListaId));
    const temListaServicoDiferente = valoresUnicos.size > 1;
    return temListaServicoDiferente;
  }

   buscaListaServico(empresaId) {

    if(empresaId !=null && empresaId !=0){
      this.faturaService.getListaServicoCadastrados(empresaId).subscribe(data => {
        this.servicosLista = data.body;
      });
    }
  }

  ListLog(faturaId){
    this.faturaService.listaLog(faturaId).subscribe(data => {
      this.Logs = data.body;
      console.log(data.body);
    });
  }

  log(faturaId: number): void {

      const dialogRef = this.dialog.open(FaturamentoLogComponent, {
        data: {
          faturaId: faturaId
        },
        maxHeight: '100vh'
      });

      dialogRef.afterClosed().subscribe(result => {
      });
    }

  getTipoLogDescricao(tipoLog: number): string {
  switch (tipoLog) {
    case 0:
      return 'Erro';
    case 1:
      return 'Sucesso';
    case 2:
      return 'Aviso';
    default:
      return 'Desconhecido';
  }
}

  // verifica se o tipo do documento fiscal é diferente de NFS-e,
  //  caso seja diferente, exibe um dialog para confirmar a alteração do tipo do documento fiscal para NFS-e
  //  e segue com a emissão da NFS-e, caso contrário, retorna false e não segue com a emissão da NFS-e
  verificaTipoDocumentoFiscal(): Promise<boolean> {

    return new Promise((resolve) => {

      const documentoFiscal = this.faturaCadastroForm.get('documentoFiscal')?.value;

      // Se já for NFS-e, segue normalmente
      if (documentoFiscal == 1) {
        resolve(true);
        return;
      }

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          titulo: "Confirmação",
          mensagem: "O campo Tipo Documento Fiscal dessa fatura não está como Nfse, deseja alterar e seguir com a emissão da Nfse?"
        }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result) {
          this.faturaCadastroForm.get('documentoFiscal')?.setValue(1);
          resolve(true);
        } else {
          resolve(false);
        }

      });

    });

  }

  async gerarNfseContaComValidacao() {
    const podeContinuar = await this.verificaTipoDocumentoFiscal();

    if (!podeContinuar) {
      return;
    }

    // atualiza fatura para garantir que o tipo do documento fiscal seja atualizado antes de gerar a NFS-e
    let faturaTemp = this.faturaCadastroForm.value;

    if (Array.isArray(faturaTemp.faturaParcelas)) {

      faturaTemp.faturaParcelas.forEach((faturaParcela: any) => {
        // Garante que valorParcela seja igual a valorLiquido para evitar inconsistências pois dto de update ler valorParcela
        // e não valorLiquido, e o valorParcela é o que é enviado para o backend no update da fatura
        faturaParcela.valorParcela = faturaParcela.valorLiquido;

      });

    }

    await this.faturaService
        .putFatura(faturaTemp, faturaTemp.faturaTipo)
        .subscribe((data) => {
          this.gerarNfseConta();
        });

  }

  async gerarSomenteNfseComValidacao() {

    const podeContinuar = await this.verificaTipoDocumentoFiscal();

    if (!podeContinuar) {
      return;
    }

    // atualiza fatura para garantir que o tipo do documento fiscal seja atualizado antes de gerar a NFS-e
    let faturaTemp = this.faturaCadastroForm.value;

    if (Array.isArray(faturaTemp.faturaParcelas)) {

      faturaTemp.faturaParcelas.forEach((faturaParcela: any) => {
        // Garante que valorParcela seja igual a valorLiquido para evitar inconsistências pois dto de update ler valorParcela
        // e não valorLiquido, e o valorParcela é o que é enviado para o backend no update da fatura
        faturaParcela.valorParcela = faturaParcela.valorLiquido;

      });

    }

    await this.faturaService
        .putFatura(faturaTemp, faturaTemp.faturaTipo)
        .subscribe((data) => {
          this.addNfse(false, false, true);
        });

  }

}
